import moment from 'moment';
import { LocaleService } from 'app/services/locale/locale.service';
import CustomerService from "app/services/customer/customer.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import store from 'appRoot/Store';
import {rootDisplayActions} from 'app/reducers/display/slice';
const NS = 'ExportCustomerCtrl';

export default function ExportCustomerCtrl(
  $scope, $mdDialog, $localStorage, $filter, ToastActions
) {
  "ngInject";

  let now;
  let fileName;
  const vm = this;

  vm.hasBookingsOnly = true;
  vm.hasRecordedBirthdayOnly = false;
  vm.loading = false;
  vm.loadError = false;
  vm.badData = false;

  // Public Methods
  vm.cancel = cancel;
  vm.exportList = exportList;

  init();

  function init() {
    const localTime = moment().format();
    const a = localTime.split(/[^0-9]/);
    now = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
  }

  function exportList() {
    vm.loadError = false;
    vm.loading = true;
    CustomerService.exportCustomers(vm.startDate, vm.endDate, vm.hasBookingsOnly, vm.hasRecordedBirthdayOnly).then(function (response) {
      const venue = AdminService.getVenue();
      fileName = (venue ? venue.name : '') + ' Customer Report ' + LocaleService.formatDateForFilename(now, 'short-2y') + '.csv';
      vm.loading = false;

      const blob = new Blob([response.data], {
        type: 'text/csv'
      });

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, fileName);
      } else {
        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = fileName;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }

      // NBI-6635 when the customer export is complete, popup should disappear
      $mdDialog.hide();
      store.dispatch(rootDisplayActions.showToastClean({
        message: 'Customer export is downloading',
      }))
    }).finally(() => {
      vm.loading = false;
    }).catch(function (error) {
      console.error('error', error);
      vm.loadError = error;
      vm.badData = (error.statusText && error.statusText == "Bad Request");
    });
  }

  function cancel() {
    $mdDialog.hide();
  }
}
